<template>
  <div>
    <nav-breadcrumb :menu="[{label: '缴退保证金'}, {label: status=='edit'?'复核':'查看'}]"/>
    <panel>
      <form-build
        :form-data="depsoitData"
        :form-columns="depsoitColumns"
        class="formTable"
      />
    </panel>
    <panel>
        <data-table
          :table-data="approvalArry"
          :columns="approvalTableColumns"
          :is-pagination-show="false"
        />
    </panel>
    <panel v-if="status=='edit'">
      <el-form :model="depsoitData" :rules="{}" ref="depsoitData" label-width="150px">
        <el-row :gutter="10" class="bg-purple xamhtrpg">
          <el-col :span="24">
            <el-form-item label="复核意见："style="width:60%">
              <el-input v-model="depsoitData.a__remarks" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="tr xzmt">
        <el-button type="primary" @click="onSave('Approved')">复核通过</el-button>
        <el-button @click="onSave('Rejected')">否决</el-button>
      </div>
    </panel>
  </div>

</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import Panel from "../../components/Panel";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "ApproveDepositApplication",
      components: {Panel},
      data() {
        return {
          approvalArry: {
            data: [],
            count: 0,
          },
          depsoitData:{
          },
          status:this.$route.query['status'] || '',
          applicationId:this.$route.query['applicationId'] || '',
          depsoitColumns:[
            {
              label: '类型',
              field: 't__applicationTypeCode',
              formatter: function (c,v) {
                return Status2CN(v)
              }
            },
            {
              label: '金额',
              field: 't__txAmount',
              formatter: function (c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '日期',
              field: 't__applicationDate',
              formatter: function (c,v) {
                return moment(v).format('YYYY-MM-DD')
              }

            },
            {
              label: '流水号',
              field: 't__reference',

            },
            {
              label: '备注',
              field: 't__remarks',
              span:24
            },
          ],
          approvalTableColumns:[
            {
              label: '节点',
              field: 'node',
              formatter: function (r, c, v) {
                return Status2CN(v)
              }
            },
            {
              label: '操作人',
              field: 'approverName'
            },
            {
              label: '操作时间',
              field: 'time',
              formatter: function (r, c, v) {
                return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
              }
            },
            {
              label: '操作结果',
              field: 'status'
            }, {
              label: '操作备注',
              field: 'remarks'
            },

          ],
        }
      },
      mounted() {
        this.getData()
      },
      methods: {
        Status2CN,
        getData:function () {
          if(this.status=='edit'){
            xhr.getApproveDepositApplication({
              't.applicationId': this.$route.query['applicationId']
            }, res=>{
              try{
                if(res.data.status == 'success') {
                  this.depsoitData = res.data.data
                  this.approvalArry.data.push(
                    {
                      node: '提交',
                      approverName: this.depsoitData.t__check1By,
                      time: this.depsoitData.t__check1Time,
                      status: '提交成功',
                      remarks: '',

                    }
                  )
                }
              }catch(e){}
            })
          }else{
            xhr.getViewDepositApplicationForApproval({
              't.applicationId': this.$route.query['applicationId']
            }, res=>{
              try{
                if(res.data.status == 'success') {
                  this.depsoitData = res.data.data
                  this.approvalArry.data.push(
                    {
                      node: '提交',
                      approverName: this.depsoitData.t__check1By,
                      time: this.depsoitData.t__check1Time,
                      status: '提交成功',
                      remarks: '',

                    }
                  )
                  this.depsoitData.approvals.filter(item=>item.a__approverId).forEach(item=>{
                    this.approvalArry.data.push(
                      {
                        node: '复核',
                        approverName: item.a__approverName,
                        time: item.a__approvingDate,
                        status: Status2CN('Deposit__'+item.a__approvingStatus),
                        remarks:item.a__remarks,

                      }
                    )
                  })



                }
              }catch(e){}
            })
          }

        },
        onSave: function (status) {
          let depsoitForm = this.depsoitData
          depsoitForm.a__approvingStatus = status
          xhr.updateApproveDepositApplication(depsoitForm, res => {
            try {
              if (res.data.status == 'success') {
                this.$router.push({
                  name: 'DepositApplicationForApprovalListView'
                })
              }
            } catch (e) {
            }
          })
        }
      },


    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApproveDepositApplication.vue